RivalIQ.apps.Insights.module('curations', function (curations, App, Backbone, Marionette, $, _, s) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    // If the active user has authorized LinkedIn but we have no LinkedIn
    // Presences for this account then the only thing they can do is become
    // a LI Admin
    const noInsightsPresences = curations.filters.noInsightsPresences({
        className: 'user-action-prompt widget-insights-nothing',
        template: '#widgetLinkedInInsightsNothingTemplate'
    });

    const noInsightsInLandscape = curations.filters.noInsightsInLandscape({
        className: 'user-action-prompt widget-insights-nothing',
        template: '#widgetLinkedInInsightsNothingInLandscapeTemplate',
        ui: {
            editConfig: '.x-edit-config'
        },
        events: {
            'click @ui.editConfig': 'onEditConfig'
        },
        regions: {
            mainView: '.main-view'
        },
        initialize: function () {
            const me = this;

            me.curation = me.options.curation;
        },
        onEditConfig: function () {
            const me = this;

            const configWidget = new RivalIQ.apps.Insights.views.LinkedInPresenceConfiguration({
                accountPresences: me.curation.accountPresences,
                accountCompanies: me.curation.accountCompanies
            });

            me.showChildView('mainView', configWidget);
        }
    });

    const channelWall = Dashboard.curations.filters.ChannelFilterFactory({
        template: '#widgetInsightsLinkedInAuthTemplate',
        upsellTemplate: '#widgetInsightsLinkedInUpsellTemplate',
        channel: RivalIQ.enums.sources.LINKEDIN
    });

    function companyAssociationConfigurator(curation) {
        if (!curation.presence) {
            return new RivalIQ.apps.Insights.views.LinkedInPresenceConfiguration({
                accountPresences: curation.accountPresences,
                accountCompanies: curation.accountCompanies
            });
        }
    }

    curations._BaseLinkedInInsightsCuration = curations._BaseInsightsCuration.extend({

        source: RivalIQ.enums.sources.LINKEDIN,

        appTitle: 'LinkedIn Analytics',

        beforeFilters: [
            curations.filters.liPresenceLoader,
            channelWall,
            noInsightsPresences,
            noInsightsInLandscape,
            companyAssociationConfigurator,
            curations.filters.insightsLoading(RivalIQ.enums.sources.LINKEDIN, '/insights/linkedin'),
            RivalIQ.apps.Dashboard.curations.filters.updateShell
        ],

        getCurationId: function () {
            const me = this;
            return s.dasherize(`${me.id.toLowerCase()}-${me.getProp('accountPresenceId')}`);
        },

        title: _.constant('LinkedIn Analytics'),

        page: function () {
            const me = this;

            const clonedPage = _.cloneDeep(RivalIQ.configuration.menus.getConfiguration().LINKEDIN_INSIGHTS);

            if (!me.presence || me.getProp('channelRedacted')) {
                _.set(clonedPage, ['metadata', 'channelRedacted'], true);
            }

            return clonedPage;
        },

        titleView: function () {
            const me = this;

            if (RivalIQ.props.channelRedacted(me.getProps(), me.getProp('source'))) {
                return me.getTitle();
            }

            const switchable = me.getSwitchableTitleView({
                hasEditButton: true,
                titleViewEditName: 'Edit Connected Pages'
            });

            me.listenTo(switchable, 'title:edit', me.onTitleEdit);

            return switchable;
        },

        onTitleEdit: function () {
            const me = this;

            RivalIQ.execute('show:modal', new App.views.LinkedInPresenceConfigurationModal({
                accountPresences: me.accountPresences,
                accountCompanies: me.accountCompanies,
                model: me.model
            }));
        },

        getSwitchableItems: function () {
            const me = this;

            if (me.presences) {
                return _(me.presences.models)
                    .sortBy(function (presence) {
                        return _.get(presence.get('sources'), [me.source, 'handle']);
                    })
                    .map(function (presence) {
                        return {
                            value: presence.get('companyId'),
                            display: me.formatPresence(presence),
                            action: function () {
                                const companyId = presence.get('companyId');
                                const path = me.getPath({
                                    companyId: companyId,
                                    accountPresenceId: presence.get('accountPresenceId'),
                                    searchTerm: ''
                                });

                                me.saveLastSelectedInsightsPresence(companyId);
                                RivalIQ.execute('history:navigate', path, {
                                    trigger: true
                                });
                            }
                        };
                    })
                    .value();
            }
        },

        getBasePath: function (props) {
            const me = this;
            props = _.extend(_.pick(me.getProps(), 'accountPresenceId'), props);
            return me.router.resolveCurationRoute(me.id, props);
        }
    });
}, window.s);
